import template from './managerAsEmployeeCalendar.html';
import controller from './managerAsEmployeeCalendar.controller';

let managerAsEmployeeCalendarComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default managerAsEmployeeCalendarComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/managerAsEmployeeCalendar/managerAsEmployeeCalendar.component.js